import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);
    const res = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ username, password, otp })
    });
    const data = await res.json();
    if (!res.ok) {
      setError(data.error);
      return;
    }
    onLogin();
    navigate('/panel');
  };

  return (
<div className="login-container">
  <h2 className="login-title">Login</h2>
  <form onSubmit={handleSubmit} className="login-form">
    {error && <div className="error-msg">{error}</div>}

    <div className="form-group">
      <label>Username:</label>
      <input
        type="text"
        value={username}
        onChange={e => setUsername(e.target.value)}
        className="form-input"
        autoComplete="username"
      />
    </div>

    <div className="form-group">
      <label>Password:</label>
      <input
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        className="form-input"
        autoComplete="current-password"
      />
    </div>

    <div className="form-group">
      <label>OTP Code:</label>
      <input
        type="text"
        value={otp}
        onChange={e => setOtp(e.target.value)}
        className="form-input"
        autoComplete="one-time-code"
      />
    </div>

    <button type="submit" className="btn-submit">Login</button>
  </form>
</div>

  );
}
